import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getUnionTaskInfo = createAsyncThunk(
  'UnionTask/getUnionTaskInfo',
  async (p, store: any) => {
    const resp = await http.post('/live/activity/union_activity_detail', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

const initialState = {
  union_id: 0,
  union_name: '',
  union_level: 'NEW',
  union_count: 0,
  count_down: 0,
  new_union_target: 1,
}
export const UnionTaskSlice = createSlice({
  name: 'rankTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUnionTaskInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export default UnionTaskSlice.reducer
